import { Alert, Link as A } from "@mui/material";
import { Link } from "react-router-dom";
import RocketIcon from '@mui/icons-material/RocketLaunch';
import { txt } from "../../services/translation";

export default function Empty({show}){

    return show && 
        <Alert severity='info' icon={<RocketIcon/>}>
            {txt('welcomeMessage')} <Link to='/courses'><A component='span'>{txt('consultCatalogueMessage')}</A></Link>.
        </Alert>


}